import React from 'react';
import {
  Tabs as MaterialTabs,
  Tab as MaterialTab,
  withStyles,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedTab: {
      color: '#0D2E68 !important',
      backgroundColor: '#CEE8FF',
      fontWeight: 800,
      minWidth: '50%',
      borderTopRightRadius: '8px !important',
      borderTopLeftRadius: '8px !important',
    },
    unselectedTab: {
      minWidth: '50%',
      borderBottom: '2px solid #CEE8FF',
      borderTopRightRadius: '8px !important',
      borderTopLeftRadius: '8px !important',
      background: '#F1FAFF',
      color: '#4A4B4E !important',
    },
    paddedTabContainer: () => ({
      [theme.breakpoints.up('lg')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    }),
  }),
);

const CustomTabs = withStyles({
  root: {
    height: 56,
    width: '100%',
  },
  indicator: {
    backgroundColor: '#0193E5',
    height: 4,
    minWidth: '48%',
  },
})(MaterialTabs);

const CustomTab = withStyles({
  root: {
    color: '#B8B8B8',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 600,
    marginTop: 8,
    minWidth: '50%',
  },
})(MaterialTab);

export type TabsProps = {
  /** The tab offset to display */
  currentTab?: number;
  /** An array with the tab names */
  tabs: string[];
  /** Called when the tab changes */
  onTabChange: (tabOffset: number) => void;
};

const Tabs = ({
  tabs,
  onTabChange,
  currentTab = 0,
}: TabsProps): JSX.Element => {
  const classes = useStyles();

  function handleTabChange(
    // eslint-disable-next-line @typescript-eslint/ban-types
    _event: React.ChangeEvent<{}>,
    newValue: number,
  ): void {
    onTabChange(newValue);
  }

  return (
    <CustomTabs
      className={classes.paddedTabContainer}
      value={currentTab}
      onChange={handleTabChange}
    >
      {tabs.map(
        (tab: string, index: number): React.ReactElement =>
          index === currentTab ? (
            <CustomTab key={tab} className={classes.selectedTab} label={tab} />
          ) : (
            <CustomTab
              key={tab}
              className={classes.unselectedTab}
              label={tab}
            />
          ),
      )}
    </CustomTabs>
  );
};

export default Tabs;
